import { render, staticRenderFns } from "./SendDocTemplateAction.vue?vue&type=template&id=54745787&scoped=true"
import script from "./SendDocTemplateAction.vue?vue&type=script&lang=js"
export * from "./SendDocTemplateAction.vue?vue&type=script&lang=js"
import style0 from "./SendDocTemplateAction.vue?vue&type=style&index=0&id=54745787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54745787",
  null
  
)

export default component.exports